import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import { emailMap } from '@/constants/blade';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import MailchimpView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';
import PolicyCheck from '@/components/PolicyCheck';
import { Upto, TopTip } from '@/components/UI/svg/Wave2';

export default function A() {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('bladeroboticlawnmower');
    const { locale } = useRouter();
    const emailConf = emailMap[locale] || emailMap.us;
    const [popupVisible, setPopupVisible] = useState(false);

    const showPolicyCheck = ['uk', 'eu', 'es', 'de', 'fr', 'it'].includes(locale);
    const [checked, setChecked] = useState(!showPolicyCheck);

    const onCheckChange = (e: any) => {
        if (e.target.checked) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    };

    useEffect(() => {
        // 离开视窗时日期、标题、文案、输入框等同时位移离开
        AniContainer.create({
            syncFromTo: [['.blade-teaser-A .sec1 .content-box .inner-content', { y: 0 }, { y: -200 }]],
            triggerElement: '.blade-teaser-A .sec1',
            triggerHook: 0,
            offset: 0,
            duration: 300,
        });

        AniContainer.create({
            syncFromTo: [['.blade-teaser-A .sec1', { opacity: 1 }, { opacity: 0 }]],
            triggerElement: '.blade-teaser-A .sec1',
            triggerHook: 0,
            offset: 0,
            duration: '100%',
        });
    }, []);

    return (
        <div className={`blade-treaser-A ${css.baldeTreaserA}`}>
            <div className="sec1">
                <div className="top-tip">
                    <TopTip />
                    <p className="text">{t('teaser.top_tip')}</p>
                </div>
                <div className="img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/blade/treaser/pc/1.webp')}
                        src={require('@publicLocal/blade/treaser/pc/1.jpg')}
                        alt={t('teaser.sec1_title')}
                        aria-label={t('teaser.sec1_title')}
                    />
                </div>
                <div className="content-box">
                    <div className="inner-content">
                        <div className="date">{t('teaser.sec1_date')}</div>
                        <div className="title">{t('teaser.sec1_title')}</div>
                        <div className="text">{t('teaser.sec1_text')}</div>
                        <div className="control">
                            {emailConf?.type === 'klaviyo' && (
                                <Klaviyo
                                    extra_properties={{
                                        custom_source: emailConf.source,
                                        $source: emailConf.source,
                                        $method_type: 'Klaviyo Form',
                                        $consent_version: 'Embed default text',
                                        $consent_form_id: emailConf.consent_form_id,
                                    }}
                                    successCallback={() => {
                                        setPopupVisible(true);
                                        try {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_submit',
                                                button_name: t('teaser.sec1_btn'),
                                                product_name: 'EcoFlow BLADE',
                                                status: 'success',
                                            });
                                            window?.fbq && window?.fbq('track', 'Lead');
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    }}
                                    errorCallback={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: t('teaser.sec1_btn'),
                                            product_name: 'EcoFlow BLADE',
                                            status: 'fail',
                                        });
                                    }}
                                >
                                    <KlaviyoView
                                        list_id={emailConf.list_id}
                                        submitText={t('teaser.sec1_btn')}
                                        placeholder={t('teaser.sec1_placeholder')}
                                        disabled={!checked}
                                    />
                                </Klaviyo>
                            )}
                            {emailConf.type === 'mailchimp' && (
                                <>
                                    <Mailchimp
                                        successCallback={() => {
                                            setPopupVisible(true);
                                            try {
                                                gtm.push({
                                                    event: 'uaEvent',
                                                    event_name: 'activity_submit',
                                                    button_name: t('teaser.sec1_btn'),
                                                    product_name: 'EcoFlow BLADE',
                                                    status: 'success',
                                                });
                                                window?.fbq('track', 'Lead');
                                            } catch (e) {
                                                console.error(e);
                                            }
                                        }}
                                        errorCallback={() => {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_submit',
                                                button_name: t('teaser.sec1_btn'),
                                                product_name: 'EcoFlow BLADE',
                                                status: 'fail',
                                            });
                                        }}
                                    >
                                        <MailchimpView
                                            action={emailConf.action}
                                            extraFields={emailConf.extraFields}
                                            submitText={t('teaser.sec1_btn')}
                                            placeholder={t('teaser.sec1_placeholder')}
                                            disabled={!checked}
                                        />
                                    </Mailchimp>
                                </>
                            )}
                            {showPolicyCheck && <PolicyCheck onCheckChange={onCheckChange} />}
                            <div className="icon">
                                {/* <NextImage
                                    webpSrc={require('@publicLocal/up_to.webp')}
                                    src={require('@publicLocal/up_to.png')}
                                    alt={t('wave2')}
                                    aria-label={t('wave2')}
                                /> */}
                                <Upto off="$600" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Popup
                visible={popupVisible}
                title={t('teaser.sec1_popup_title')}
                content={t.rich('teaser.sec1_popup_text')}
                buttonText={t('teaser.sec1_popup_btn')}
                onCancel={() => setPopupVisible(false)}
                btnLink={emailConf.popupBtnLink}
            />
            <style jsx global>
                {`
                    .ant-modal-content .popup-btn {
                        padding: 0 97.5px;
                    }
                    .ant-modal-content .popup-btn:hover {
                        background: #1e5ef4;
                    }
                    .ant-modal-content .ant-modal-close {
                        right: 30px;
                        left: auto;
                        width: 40px;
                        height: 40px;
                    }
                    .ant-modal-content .ant-modal-close .ant-modal-close-x {
                        width: 40px;
                        height: 40px;
                        font-size: 18px;
                        background: #999;
                        border: 0;
                        color: #03060b;
                    }
                    .ant-modal-content .ant-modal-close .ant-modal-close-x:hover {
                        background: #eee;
                    }
                `}
            </style>
        </div>
    );
}
